import { render, staticRenderFns } from "./ImprimirBuro.vue?vue&type=template&id=ca9b87c0&scoped=true&lang=html&"
import script from "./ImprimirBuro.vue?vue&type=script&lang=js&"
export * from "./ImprimirBuro.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirBuro.vue?vue&type=style&index=0&id=ca9b87c0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9b87c0",
  null
  
)

export default component.exports